module.exports = __webpack_public_path__ + "media/images/icons/ic-calendar-0716bfe80079f8e0c189818444493b39.svg";